export class PhoneWidgetError extends Error {
  constructor(message: string) {
    super(message);

    this.name = 'PhoneWidgetError';
  }
}
